import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

// 員工狀態管理 hook (改用姓名識別)
export function useEmployee(employeeName) {
  const [status, setStatus] = useState('上班'); // '上班' | '下班'
  const [clockTime, setClockTime] = useState(null);
  const [workHours, setWorkHours] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  // 取得當日打卡狀態
  const fetchStatus = useCallback(async () => {
    if (!employeeName) return;

    try {
      const [statusRes, hoursRes] = await Promise.all([
        api.getStatus(employeeName),
        api.getWorkHours(employeeName)
      ]);

      if (statusRes.success) {
        setStatus(statusRes.data.clockType || '上班');
        setClockTime(statusRes.data.clockInTime);
      }

      if (hoursRes.success) {
        setWorkHours(hoursRes.data.workHours || 0);
      }
    } catch (err) {
      console.error('取得打卡狀態失敗:', err);
    } finally {
      setIsLoading(false);
    }
  }, [employeeName]);

  // 打卡成功後更新狀態
  const updateAfterClockIn = (newClockType, timestamp) => {
    setStatus(newClockType === '上班' ? '下班' : null);
    setClockTime(timestamp);
  };

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return {
    status,
    clockTime,
    workHours,
    isLoading,
    refresh: fetchStatus,
    updateAfterClockIn
  };
}

// 員工登入 hook (管理 Token)
export function useEmployeeAuth() {
  const [employeeName, setEmployeeName] = useState(() => {
    try {
      const name = localStorage.getItem('employeeName');
      return name ? String(name) : '';
    } catch {
      return '';
    }
  });
  const [token, setToken] = useState(() => {
    try {
      const t = localStorage.getItem('employeeToken');
      return t ? String(t) : '';
    } catch {
      return '';
    }
  });

  const login = (name) => {
    // 產生簡單的 Token
    // 使用 encodeURI + unescape 處理 Unicode（如中文姓名），避免 btoa 拋出 DOMException
    const jsonStr = JSON.stringify({ name, time: Date.now() });
    const newToken = btoa(unescape(encodeURIComponent(jsonStr)));
    localStorage.setItem('employeeToken', newToken);
    localStorage.setItem('employeeName', name);
    setToken(newToken);
    setEmployeeName(name);
  };

  const logout = () => {
    localStorage.removeItem('employeeToken');
    localStorage.removeItem('employeeName');
    setToken('');
    setEmployeeName('');
  };

  return {
    employeeName,
    token,
    isLoggedIn: !!employeeName,
    login,
    logout
  };
}